import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const GroupsByPerson = ({ byPerson }) => {
  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={12}>
        {byPerson.map((user) => {
          return (
            <Accordion
              key={user?.user?._id}
              TransitionProps={{ unmountOnExit: true }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  {" "}
                  {user?.user?.profile?.firstName}{" "}
                  {user?.user?.profile?.lastName}{" | "}
                  {"Rounds: "}
                  {user?.rounds?.length}
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <List>
                  <ListItem>
                    <Grid container direction="row">
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              xs: "0.75rem", // Extra-small devices
                              sm: "0.875rem", // Small devices
                              md: "1rem", // Medium devices and up
                            },
                          }}
                        >
                          Round
                        </Typography>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: {
                              xs: "0.75rem", // Extra-small devices
                              sm: "0.875rem", // Small devices
                              md: "1rem", // Medium devices and up
                            },
                          }}
                        >
                          Table
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {user?.rounds.map((round, r) => {
                    return (
                      <ListItem key={`${r}-${user?.user?._id}`}>
                               <Grid container direction="row">
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          sx={{
                            fontSize: {
                              xs: "0.75rem", // Extra-small devices
                              sm: "0.875rem", // Small devices
                              md: "1rem", // Medium devices and up
                            },
                          }}
                        >
                          {round?.round}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2}>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          sx={{
                            fontSize: {
                              xs: "0.75rem", // Extra-small devices
                              sm: "0.875rem", // Small devices
                              md: "1rem", // Medium devices and up
                            },
                          }}
                        >
                          {round?.table}
                        </Typography>
                      </Grid>
                    </Grid>
                      </ListItem>
                    );
                  })}
                </List>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default GroupsByPerson;
